import axios from "axios";

export const getControlAPI = async () => {
  const response = await axios({
    method: "get",
    url: `/api/controls`,
  });

  return response.data;
};
